var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nosotros'),_c('xiami'),_c('productos'),_c('footer-app'),(_vm.buttonScrollToTop)?_c('button',{staticClass:"btn btn-lg shadow sticky-button rounded-circle position-fixed end-0 sticky-bottom m-5",attrs:{"type":"button"},on:{"click":_vm.toTop}},[_c('i',{staticClass:"bi bi-arrow-up"})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }